import { useEffect } from 'react';

const MIN_HEIGHT = 200;

export const useSendHeightToParent = () => {
  useEffect(() => {
    const sendHeight = () => {
      const height = Math.max(document.body.scrollHeight, MIN_HEIGHT);
      window.parent.postMessage({ type: 'setHeight', height }, '*');
    };

    sendHeight();

    const resizeObserver = new ResizeObserver(sendHeight);
    resizeObserver.observe(document.body);
    window.addEventListener('resize', sendHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', sendHeight);
    };
  }, []);
};
